import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import "./VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { useAuth } from "../../../../Store/AuthContext";
import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";
import axios from "axios";

DataTable.use(DT);

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadAssignDataTable() {
  const { userID, RendomTokenfetch, userRoll, vendorRollID } = useAuth();
  const navigate = useNavigate();
  const [VendorLeads, setVendorLeads] = useState([]);
  const [vendorStatus, setvendorStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Filterloading, setFilterloading] = useState(false);
  const tableRef = useRef(null);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    workStatus: "",
  });
  const filtersRef = useRef(filters);

  // *********Fetch Vendor Status on component mount********
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("vendor_role", vendorRollID);
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}vendorstatusshow`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setvendorStatus(response.data.statusdata || []);
            }
            if (response.data.Status === "0") {
              setvendorStatus([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID, vendorRollID]);

  const [tempFilters, setTempFilters] = useState(filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    filtersRef.current = filters;

    const tableInstance = tableRef.current?.dt();
    if (tableInstance) {
      setFilterloading(true); // Show loader
      // console.log("Reloading with filters:", filtersRef.current);

      tableInstance.ajax.reload(() => {
        setFilterloading(false); // Hide loader after reload finishes
      });
    }
  }, [filters]);
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFilters(tempFilters); // triggers reload through useEffect
  };

  const newspaperClearFilter = () => {
    const clearedFilters = {
      startDate: "",
      endDate: "",
      workStatus: "",
    };
    setTempFilters(clearedFilters);
    setFilters(clearedFilters); // useEffect will handle reload
  };

  const columns = [
    {
      title: `<input type="checkbox" id="selectAll" name="allrowCheckStaus"/>`, // Header checkbox
      data: null,
      orderable: false,
      searchable: false,
      render: (data, type, row) => {
        return `<input type="checkbox" class="row-checkbox" id="rowcheck${row.id}" name="rowcheckStatuschange" data-id="${row.id}" />`;
      },
    },

    {
      title: "Lead Number",
      data: "id",
      // render: (data, type, row) => {
      //   return `<a href="/lead-assing-details/${row.id}" class="lead-link">${data}</a>`;
      // <a href="/lead-assing-details/${row.id}" class="lead-link fw-600" style="color: blue;" title="View">${data}</a>
      // },
    },
    {
      title: "Applicant Name",
      data: "name",
      render: (data, type, row) => {
        return `<span  data-id="${row.id}" class="lead-link fw-600" style="color: blue; cursor: pointer;" title="View">${data}</span>`;
      },
    },
    {
      title: "Lead Status",
      data: "status",
      render: (data, type, row) => {
        return `<span class="badge" style="color:${row.statuscolor};background-color:${row.statusbg};">${data}</span>`;
      },
    },
    { title: "Service", data: "service" },
    { title: "Start Date", data: "date" },
  ];

  //********Handle All Links data Update,fetch ETC********
  useEffect(() => {
    const handleSelectAll = function () {
      const isChecked = $(this).is(":checked");
      $(".row-checkbox").prop("checked", isChecked);
    };
    const handleRowCheckbox = function () {
      const allChecked =
        $(".row-checkbox").length === $(".row-checkbox:checked").length;
      $("#selectAll").prop("checked", allChecked);
    };

    const handleRowClick = function (event) {
      const leadId = $(this).data("id");
      const rowData = VendorLeads.find((lead) => lead.id.toString() === leadId);
      if (rowData?.vendor_accept_status === "0") return;
      navigate(`/lead-assing-details/${leadId}`, { replace: false });
    };

    $(document).on("focus", ".lead-status-dropdown", function () {
      const previousVal = $(this).val();
      $(this).data("previous-value", previousVal);
    });

    $(document).on("change", "#selectAll", handleSelectAll);
    $(document).on("change", ".row-checkbox", handleRowCheckbox);
    $(document).on("click", ".lead-link", handleRowClick);

    return () => {
      $(document).off("change", "#selectAll", handleSelectAll);
      $(document).off("change", ".row-checkbox", handleRowCheckbox);
      $(document).off("click", ".lead-link", handleRowClick);
    };
  }, [navigate, VendorLeads, userID, RendomTokenfetch, userRoll, vendorRollID]);

  // useEffect(() => {
  //   $(document).on("click", ".lead-link", function (event) {
  //     event.preventDefault();
  //     const leadId = $(this).attr("href").split("/").pop();
  //     navigate(`/lead-assing-details/${leadId}`);
  //   });
  // }, [navigate]);

  if (loading || Filterloading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      {/* ************Filter HTML********* */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget">
            <div className="tabs-box">
              <div className="widget-title  px-2 py-1 newsvendorfliderheading">
                <p className="mb-0">FILTER BY</p>
              </div>
              <div className="widget-content p-3">
                <form className="was-validated" onSubmit={handleFilterSubmit}>
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="startDate">Start Date</label>
                      <input
                        type="date"
                        id="startDate"
                        className="form-control"
                        name="startDate"
                        value={tempFilters.startDate}
                        onChange={handleFilterChange}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="endDate">End Date</label>
                      <input
                        type="date"
                        id="endDate"
                        className="form-control"
                        name="endDate"
                        value={tempFilters.endDate}
                        onChange={handleFilterChange}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="workStatus">Lead Status</label>
                      <select
                        className="chosen-select form-control"
                        name="workStatus"
                        id="workStatus"
                        value={tempFilters.workStatus}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select</option>
                        {vendorStatus.map((val) => (
                          <option value={val.id} key={val.id}>
                            {val.lead_status}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 text-center mt-3">
                    <button className="theme-btn btn-style-three submitbtn">
                      Submit
                    </button>
                    <span
                      className="mx-4 theme-btn btn-style-three submitbtn"
                      onClick={newspaperClearFilter}
                    >
                      Clear Filter
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/************ Data Table Ajax *********** */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget">
            <div className="tabs-box"></div>
            <div className="widget-content py-3 table-responsive">
              <DataTable
                className="table table-striped table-bordered vendordatatable"
                ref={tableRef}
                columns={columns}
                responsive={false}
                noHeader={true}
                style={{ tableLayout: "auto", width: "100%" }}
                processing={true}
                options={{
                  responsive: true,
                  ordering: false,
                  dom: "Bfrtip", // Adds the buttons at the top

                  buttons: [
                    {
                      extend: "copy",
                      text: `<i class="fa fa-clone"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Copy to clipboard",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "excelHtml5",
                      text: `<i class="fa fa-file-excel-o"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Export to Excel",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "pdfHtml5",
                      text: `<i class="fa fa-file-pdf-o"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Export to PDF",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "print",
                      text: '<i class="fa fa-print"></i>',
                      className: "btn btn-sm",
                      titleAttr: "Print table",
                      exportOptions: {
                        columns: ":visible",
                        modifier: {
                          page: "all",
                        },
                      },
                    },
                    {
                      extend: "colvis",
                      text: "Column Visibility", // Boxicon for Column Visibility
                      className: "btn btn-sm",
                      titleAttr: "Toggle column visibility",
                    },
                    {
                      extend: "pageLength",
                      text: "Show Rows",
                      className: "btn btn-sm",
                      titleAttr: "Change Number of Rows Displayed",
                    },
                  ],
                  lengthMenu: [
                    [10, 50, 100, 150, 200, -1],
                    [10, 50, 100, 150, 200, "All"],
                  ],

                  colVis: {
                    restore: true,
                  },
                  stateSave: true,
                  deferRender: true,
                  scrollCollapse: true,
                  scroller: true,
                  pagingType: "full_numbers",
                  fixedHeader: true,
                  autoWidth: false,
                  serverSide: true,
                  paging: true,
                  pageLength: 10,
                  ajax: (data, callback) => {
                    const currentFilters = filtersRef.current;

                    const page = Math.floor(data.start / data.length) + 1;
                    const limit = data.length;

                    axios
                      .get(`${WebsiteAPIurl}allLeadsvendor`, {
                        params: {
                          user_id: userID,
                          start_date: currentFilters.startDate,
                          end_date: currentFilters.endDate,
                          status: currentFilters.workStatus,
                          page: page,
                          limit: limit,
                          search: data.search.value,
                        },
                        headers: { Authorization: RendomTokenfetch },
                      })
                      .then((res) => {
                        const r = res.data;

                        const total = parseInt(r.total_length) || 0;
                        const data = Array.isArray(r.leaddata)
                          ? r.leaddata
                          : [];

                        setVendorLeads(data);
                        callback({
                          data: r.leaddata,
                          recordsTotal: total,
                          recordsFiltered: total,
                        });
                      })
                      .catch(() =>
                        callback({
                          data: [],
                          recordsTotal: 0,
                          recordsFiltered: 0,
                        })
                      );
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
